import { FC } from 'react';
import { H2 } from '../../../../common/Headings/Headings.styles';
import { TableRowWrapper, TableWrapper } from '../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import Button from '../../../../components/Button/Button';
import { Variant } from '../../../../components/Button/Button.types';
import Table from '../../../../components/Table/Table';
import { Buttons, StyledReviewChanges } from './ReviewChanges.styles';
import { ReviewChangesProps } from './ReviewChanges.types';

const ReviewChanges: FC<ReviewChangesProps> = ({
  selectedRawProds,
  selectedRecipes,
  setStep,
  handleSave,
  isLoading,
}) => {
  const editRawProd = () => setStep(0);
  const editRecipe = () => setStep(1);

  return (
    <StyledReviewChanges>
      <H2>Review your changes</H2>
      <TableRowWrapper>
        <TableWrapper>
          <Table
            rowData={selectedRawProds}
            headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: editRawProd }]}
            showHeader
            headerTitle='Add Raw Product'
            floatingFiltersHeight={0}
            returnedRecords={selectedRawProds.length}
            columnDefs={[
              { minWidth: 120, flex: 1, field: 'moaRawProdNo', headerName: 'Raw Product' },
              { minWidth: 220, flex: 2, field: 'moaRawProdDesc', headerName: 'Description' },
              {
                minWidth: 120,
                flex: 1,
                field: 'usageAmount',
                headerName: 'Usage Amt',
                resizable: false,
              },
            ]}
          />
        </TableWrapper>
        <TableWrapper>
          <Table
            rowData={selectedRecipes}
            headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: editRecipe }]}
            showHeader
            headerTitle='Affected Recipes'
            floatingFiltersHeight={0}
            returnedRecords={selectedRecipes.length}
            columnDefs={[
              { minWidth: 220, flex: 1, field: 'specNo', headerName: 'Recipe' },
              { minWidth: 320, flex: 1, field: 'description', headerName: 'Description', resizable: false },
            ]}
          />
        </TableWrapper>
      </TableRowWrapper>
      <Buttons>
        <Button label='Back' testId='reviewBackButton' variant={Variant.Secondary} onClick={editRecipe} />
        <Button label='Save' testId='reviewSaveButton' onClick={handleSave} isLoading={isLoading} />
      </Buttons>
    </StyledReviewChanges>
  );
};

export default ReviewChanges;
